// exported from FHIR/FHIR-Resources-SDK-SourceFiles/projects/fhir-observation/src/lib at 2021. Aug. 04. 11:42 - Norbert Eszes

export interface CodeModel {
    system: string;
    code: string;
    display: string;
    text: string;
}
export class ObservationConstants {
    static readonly ObservationSystem: string = 'http://loinc.org';
    static readonly MillimetreOfMercury: string = 'Hgmm';
    static readonly Minute: string = 'min';
    static readonly Kilogram: string = 'kg';
    static readonly BeatsPerMinute: string = 'beats/min';
    static readonly BeatsPerMinuteShort: string = 'bpm';
    static readonly Kilometer: string = 'km';
    static readonly Meter: string = 'm';
    static readonly CentiMeter: string = 'cm';
    static readonly Calories: string = 'kcal';
    static readonly Steps: string = 'steps';
    static readonly MillimolesPerLiter: string = 'mmol/L';
    static readonly PicogramPerMililiter: string = 'pg/mL';
    static readonly Milliliter: string = 'mL';
    static readonly Liter: string = 'L';
    static readonly LiterPerSec: string = 'L/Sec';
    static readonly Percentage: string = '%';
    static readonly gramm: string = 'g';
    static readonly unit: string = 'unit';
    static readonly score: string = 'score';
    static readonly MilligramPerLiter: string = 'mg/L';
    static readonly NanogramsPerMilliliter: string = 'ng/mL';

    // extended info

    static readonly BMIRatioCode: string = '39156-5';
    static readonly BMIRatioDisplay: string = 'Body mass index (BMI) [Ratio]';
    static readonly BMIRatioText: string = 'BMI ratio';

    static readonly BMIRatioCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BMIRatioCode,
        display: ObservationConstants.BMIRatioDisplay,
        text: ObservationConstants.BMIRatioText
    };

    static readonly BMIRationUnit = 'kg/m2';

    // extended info end

    static readonly ElectrophysiologyStudyCode: string = '18750-0';
    static readonly ElectrophysiologyStudyDisplay: string = 'Electrophysiology study';
    static readonly ElectrophysiologyStudyText: string = 'Electrophysiology study';

    static readonly ElectrophysiologyStudyCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ElectrophysiologyStudyCode,
        display: ObservationConstants.ElectrophysiologyStudyDisplay,
        text: ObservationConstants.ElectrophysiologyStudyText
    };

    static readonly BloodPressureCode: string = '55284-4';
    static readonly BloodPressureDisplay: string = 'Blood pressure systolic & diastolic';
    static readonly BloodPressureText: string = 'BloodPressure';

    static readonly BloodPressureCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodPressureCode,
        display: ObservationConstants.BloodPressureDisplay,
        text: ObservationConstants.BloodPressureText
    };

    static readonly PhysicalActivityPanelCode: string = '82287-4';
    static readonly PhysicalActivityPanelDisplay: string = 'Physical activity panel';
    static readonly PhysicalActivityPanelText: string = 'Physical activity panel';

    static readonly PhysicalActivityPanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PhysicalActivityPanelCode,
        display: ObservationConstants.PhysicalActivityPanelDisplay,
        text: ObservationConstants.PhysicalActivityPanelText
    };

    static readonly SystolicCode: string = '8480-6';
    static readonly SystolicDisplay: string = 'Intravascular systolic';
    static readonly SystolicText: string = 'Systolic';

    static readonly SystolicCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SystolicCode,
        display: ObservationConstants.SystolicDisplay,
        text: ObservationConstants.SystolicText
    };

    static readonly DiastolicCode: string = '8462-4';
    static readonly DiastolicDisplay: string = 'Intravascular diastolic';
    static readonly DiastolicText: string = 'Diastolic';

    static readonly DiastolicCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.DiastolicCode,
        display: ObservationConstants.DiastolicDisplay,
        text: ObservationConstants.DiastolicText
    };

    static readonly BodyWeightCode: string = '29463-7';
    static readonly BodyWeightDisplay: string = 'Body Weight';
    static readonly BodyWeightText: string = 'Body Weight';

    static readonly BodyWeightCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BodyWeightCode,
        display: ObservationConstants.BodyWeightDisplay,
        text: ObservationConstants.BodyWeightText
    };

    static readonly ActivityCode: string = '73985-4';
    static readonly ActivityDisplay: string = 'Exercise Activity';
    static readonly ActivityText: string = 'Activity';

    static readonly ActivityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ActivityCode,
        display: ObservationConstants.ActivityDisplay,
        text: ObservationConstants.ActivityText
    };

    static readonly MaxHeartBeatCode: string = '55422-0';
    static readonly MaxHeartBeatDisplay: string = 'Heart rate Encounter maximum';
    static readonly MaxHeartBeatText: string = 'Maximum Heart rate';

    static readonly MaxHeartBeatCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.MaxHeartBeatCode,
        display: ObservationConstants.MaxHeartBeatDisplay,
        text: ObservationConstants.MaxHeartBeatText
    };

    static readonly DistanceCode: string = '41953-1';
    static readonly DistanceDisplay: string = 'Exercise distance';
    static readonly DistanceText: string = 'Exercise distance';

    static readonly DistanceCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.DistanceCode,
        display: ObservationConstants.DistanceDisplay,
        text: ObservationConstants.DistanceText
    };

    static readonly BurntCaloriesCode: string = '55421-2';
    static readonly BurntCaloriesDisplay: string = 'Calories Burnt Machine estimate';
    static readonly BurntCaloriesText: string = 'Calories Burnt';

    static readonly BurntCaloriesCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BurntCaloriesCode,
        display: ObservationConstants.BurntCaloriesDisplay,
        text: ObservationConstants.BurntCaloriesText
    };

    static readonly EcgCode: string = '34534-8';
    static readonly EcgDisplay: string = 'EKG 12 Channel panel';
    static readonly EcgText: string = 'EKG test';

    static readonly EcgCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.EcgCode,
        display: ObservationConstants.EcgDisplay,
        text: ObservationConstants.EcgText
    };

    static readonly LaboratoryTestCode: string = '52482-7';
    static readonly LaboratoryTestDisplay: string = 'Laboratory';
    static readonly LaboratoryTestText: string = 'Laboratory test';

    static readonly LaboratoryTestCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.LaboratoryTestCode,
        display: ObservationConstants.LaboratoryTestDisplay,
        text: ObservationConstants.LaboratoryTestText
    };

    static readonly HeartRateCode: string = '8867-4';
    static readonly HeartRateDisplay: string = 'Heart rate';
    static readonly HeartRateText: string = 'Heart rate';

    static readonly HeartRateCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateCode,
        display: ObservationConstants.HeartRateDisplay,
        text: ObservationConstants.HeartRateText
    };

    static readonly TriglycerideCode: string = '3043-7';
    static readonly TriglycerideDisplay: string = 'Triglyceride [Moles/volume] in Blood';
    static readonly TriglycerideText: string = 'Triglyceride';

    static readonly TriglycerideCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.TriglycerideCode,
        display: ObservationConstants.TriglycerideDisplay,
        text: ObservationConstants.TriglycerideText
    };

    static readonly LDLCholesterolCode: string = '53133-5';
    static readonly LDLCholesterolDisplay: string = 'Cholesterol in LDL [Moles/volume] in Body fluid';
    static readonly LDLCholesterolText: string = 'LDL-Cholesterol';

    static readonly LDLCholesterolCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.LDLCholesterolCode,
        display: ObservationConstants.LDLCholesterolDisplay,
        text: ObservationConstants.LDLCholesterolText
    };

    static readonly HDLCholesterolCode: string = '50840-8';
    static readonly HDLCholesterolDisplay: string = 'Cholesterol in HDL [Moles/volume] in Body fluid';
    static readonly HDLCholesterolText: string = 'HDL-Cholesterol';

    static readonly HDLCholesterolCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HDLCholesterolCode,
        display: ObservationConstants.HDLCholesterolDisplay,
        text: ObservationConstants.HDLCholesterolText
    };

    static readonly TotalCholesterolCode: string = '12183-0';
    static readonly TotalCholesterolDisplay: string = 'Cholesterol [Moles/volume] in Body fluid';
    static readonly TotalCholesterolText: string = 'Sum Cholesterol';

    static readonly TotalCholesterolCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.TotalCholesterolCode,
        display: ObservationConstants.TotalCholesterolDisplay,
        text: ObservationConstants.TotalCholesterolText
    };

    static readonly SmokingCode: string = '63638-1';
    static readonly SmokingDisplay: string = 'Smoking status';
    static readonly SmokingText: string = 'Smoking';

    static readonly SmokingCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SmokingCode,
        display: ObservationConstants.SmokingDisplay,
        text: ObservationConstants.SmokingText
    };

    static readonly AlcoholCode: string = '74205-6';
    static readonly AlcoholDisplay: string = 'Alcohol use';
    static readonly AlcoholText: string = 'Alcohol';

    static readonly AlcoholCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.AlcoholCode,
        display: ObservationConstants.AlcoholDisplay,
        text: ObservationConstants.AlcoholText
    };

    static readonly CoffeeCode: string = '61480-0';
    static readonly CoffeeDisplay: string = 'How often did you drink brewed coffee, not decaffeinated';
    static readonly CoffeeText: string = 'Coffee';

    static readonly CoffeeCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CoffeeCode,
        display: ObservationConstants.CoffeeDisplay,
        text: ObservationConstants.CoffeeText
    };

    static readonly UricAcidCode: string = '14934-4';
    static readonly UricAcidDisplay: string = 'Urate [Moles/volume] in Urine';
    static readonly UricAcidText: string = 'Uric acid';

    static readonly UricAcidCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.UricAcidCode,
        display: ObservationConstants.UricAcidDisplay,
        text: ObservationConstants.UricAcidText
    };

    static readonly SerumAcidCode: string = '14800-7';
    static readonly SerumAcidDisplay: string = 'Iron binding capacity [Moles/volume] in Serum or Plasma';
    static readonly SerumAcidText: string = 'Serum Iron';

    static readonly SerumAcidCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SerumAcidCode,
        display: ObservationConstants.SerumAcidDisplay,
        text: ObservationConstants.SerumAcidText
    };

    static readonly BioparametersCode: string = '28636-9';
    static readonly BioparametersDisplay: string = 'Initial evaluation note';
    static readonly BioparametersText: string = 'Bioparameters';

    static readonly BioparametersCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BioparametersCode,
        display: ObservationConstants.BioparametersDisplay,
        text: ObservationConstants.BioparametersText
    };

    static readonly LifeStyleCode: string = '83332-7';
    static readonly LifeStyleDisplay: string = 'Lifestyle behaviors impacting physical or mental well-being [PCAM]';
    static readonly LifeStyleText: string = 'Lifestyle/Feeding/Pleasure agents';

    static readonly LifeStyleCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.LifeStyleCode,
        display: ObservationConstants.LifeStyleDisplay,
        text: ObservationConstants.LifeStyleText
    };

    static readonly BloodTypeCode: string = '882-1';
    static readonly BloodTypeDisplay: string = 'ABO and Rh group [Type] in Blood]';
    static readonly BloodTypeText: string = 'Blood type';

    static readonly BloodTypeCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodTypeCode,
        display: ObservationConstants.BloodTypeDisplay,
        text: ObservationConstants.BloodTypeText
    };

    static readonly ExaminationCode: string = '75426-7';
    static readonly ExaminationDisplay: string = 'Cardiology procedure note';
    static readonly ExaminationText: string = 'Examination';

    static readonly ExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ExaminationCode,
        display: ObservationConstants.ExaminationDisplay,
        text: ObservationConstants.ExaminationText
    };

    static readonly EcgExaminationCode: string = '18810-2';
    static readonly EcgExaminationDisplay: string = 'EKG Study observation overall (narrative)';
    static readonly EcgExaminationText: string = 'EKG';

    static readonly EcgExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.EcgExaminationCode,
        display: ObservationConstants.EcgExaminationDisplay,
        text: ObservationConstants.EcgExaminationText
    };

    static readonly LoadedEcgExaminationCode: string = '18752-6';
    static readonly LoadedEcgExaminationDisplay: string = 'Exercise stress test study';
    static readonly LoadedEcgExaminationText: string = 'Exercise stress EKG';

    static readonly LoadedEcgExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.LoadedEcgExaminationCode,
        display: ObservationConstants.LoadedEcgExaminationDisplay,
        text: ObservationConstants.LoadedEcgExaminationText
    };

    static readonly HeartUltrasoundExaminationCode: string = '34552-0';
    static readonly HeartUltrasoundExaminationDisplay: string = '2D echocardiogram panel';
    static readonly HeartUltrasoundExaminationText: string = 'Echocardiogram';

    static readonly HeartUltrasoundExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartUltrasoundExaminationCode,
        display: ObservationConstants.HeartUltrasoundExaminationDisplay,
        text: ObservationConstants.HeartUltrasoundExaminationText
    };

    static readonly SixMinuteWalkTestExaminationCode: string = '64098-7';
    static readonly SixMinuteWalkTestExaminationDisplay: string = 'Distance walked in 6 minutes';
    static readonly SixMinuteWalkTestExaminationText: string = '6 minutes walking test';

    static readonly SixMinuteWalkTestExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SixMinuteWalkTestExaminationCode,
        display: ObservationConstants.SixMinuteWalkTestExaminationDisplay,
        text: ObservationConstants.SixMinuteWalkTestExaminationText
    };

    static readonly ChestXRayExaminationCode: string = '30745-4';
    static readonly ChestXRayExaminationDisplay: string = 'XR Chest Views';
    static readonly ChestXRayExaminationText: string = 'Chest X-ray';

    static readonly ChestXRayExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ChestXRayExaminationCode,
        display: ObservationConstants.ChestXRayExaminationDisplay,
        text: ObservationConstants.ChestXRayExaminationText
    };

    static readonly ChestCTExaminationCode: string = '24627-2';
    static readonly ChestCTExaminationDisplay: string = 'CT Chest';
    static readonly ChestCTExaminationText: string = 'Chest CT';

    static readonly ChestCTExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ChestCTExaminationCode,
        display: ObservationConstants.ChestCTExaminationDisplay,
        text: ObservationConstants.ChestCTExaminationText
    };

    static readonly AngioExaminationCode: string = '24620-7';
    static readonly AngioExaminationDisplay: string = 'RF Catheter Views for patency check W contrast via catheter';
    static readonly AngioExaminationText: string = 'Angio';

    static readonly AngioExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.AngioExaminationCode,
        display: ObservationConstants.AngioExaminationDisplay,
        text: ObservationConstants.AngioExaminationText
    };

    static readonly RespiratoryFunctionTestExaminationCode: string = '52510-5';
    static readonly RespiratoryFunctionTestExaminationDisplay: string = 'Respiratory status';
    static readonly RespiratoryFunctionTestExaminationText: string = 'Respiratory function test';

    static readonly RespiratoryFunctionTestExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.RespiratoryFunctionTestExaminationCode,
        display: ObservationConstants.RespiratoryFunctionTestExaminationDisplay,
        text: ObservationConstants.RespiratoryFunctionTestExaminationText
    };

    static readonly HeartCTExaminationCode: string = '58744-4';
    static readonly HeartCTExaminationDisplay: string = 'CT Heart';
    static readonly HeartCTExaminationText: string = 'Heart CT';

    static readonly HeartCTExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartCTExaminationCode,
        display: ObservationConstants.HeartCTExaminationDisplay,
        text: ObservationConstants.HeartCTExaminationText
    };

    static readonly HeartMRExaminationCode: string = '24748-6';
    static readonly HeartMRExaminationDisplay: string = 'MR Heart';
    static readonly HeartMRExaminationText: string = 'Heart MR';

    static readonly HeartMRExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartMRExaminationCode,
        display: ObservationConstants.HeartMRExaminationDisplay,
        text: ObservationConstants.HeartMRExaminationText
    };

    static readonly HemodynamicExaminationExaminationCode: string = '56848-5';
    static readonly HemodynamicExaminationExaminationDisplay: string = 'Invasive hemodynamic monitoring (set)';
    static readonly HemodynamicExaminationExaminationText: string = 'Hemodynamic test';

    static readonly HemodynamicExaminationExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HemodynamicExaminationExaminationCode,
        display: ObservationConstants.HemodynamicExaminationExaminationDisplay,
        text: ObservationConstants.HemodynamicExaminationExaminationText
    };

    static readonly GeneticTestExaminationCode: string = '51969-4';
    static readonly GeneticTestExaminationDisplay: string = 'Genetic analysis report';
    static readonly GeneticTestExaminationText: string = 'Genetic analysis';

    static readonly GeneticTestExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.GeneticTestExaminationCode,
        display: ObservationConstants.GeneticTestExaminationDisplay,
        text: ObservationConstants.GeneticTestExaminationText
    };

    static readonly PROBNPExaminationCode: string = '71425-3';
    static readonly PROBNPExaminationDisplay: string = 'Natriuretic peptide.B prohormone N-Terminal [Mass/volume] in Blood by Immunoassay';
    static readonly PROBNPExaminationText: string = 'PROBNP';

    static readonly PROBNPExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PROBNPExaminationCode,
        display: ObservationConstants.PROBNPExaminationDisplay,
        text: ObservationConstants.PROBNPExaminationText
    };

    static readonly StepActivityCode: string = '41950-7';
    static readonly StepActivityDisplay: string = 'Number of steps in 24 hour Measured';
    static readonly StepActivityText: string = 'MiBand number of steps';

    static readonly StepActivityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.StepActivityCode,
        display: ObservationConstants.StepActivityDisplay,
        text: ObservationConstants.StepActivityText
    };

    static readonly DistanceActivityCode: string = '41953-1';
    static readonly DistanceActivityDisplay: string = 'Distance walked in 24 hour Calculated';
    static readonly DistanceActivityText: string = 'Distance walked';

    static readonly DistanceActivityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.DistanceActivityCode,
        display: ObservationConstants.DistanceActivityDisplay,
        text: ObservationConstants.DistanceActivityText
    };

    static readonly BurntCaloriesActivityCode: string = '41979-6';
    static readonly BurntCaloriesActivityDisplay: string = 'Calories Burnt in 24 hour Calculated';
    static readonly BurntCaloriesActivityText: string = 'Calories Burnt';

    static readonly BurntCaloriesActivityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BurntCaloriesActivityCode,
        display: ObservationConstants.BurntCaloriesActivityDisplay,
        text: ObservationConstants.BurntCaloriesActivityText
    };

    static readonly FluidOutputCode: string = '9179-3';
    static readonly FluidOutputDisplay: string = 'Fluid output peritoneal drain';
    static readonly FluidOutputText: string = 'Fluid output';

    static readonly FluidOutputCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FluidOutputCode,
        display: ObservationConstants.FluidOutputDisplay,
        text: ObservationConstants.FluidOutputText
    };

    static readonly FluidInputCode: string = '9009-2';
    static readonly FluidInputDisplay: string = 'Fluid intake peritoneal Measured';
    static readonly FluidInputText: string = 'Fluid intake';

    static readonly FluidInputCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FluidInputCode,
        display: ObservationConstants.FluidInputDisplay,
        text: ObservationConstants.FluidInputText
    };

    static readonly BodyHeightCode: string = '8302-2';
    static readonly BodyHeightDisplay: string = 'Body height';
    static readonly BodyHeightText: string = 'Body height';

    static readonly BodyHeightCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BodyHeightCode,
        display: ObservationConstants.BodyHeightDisplay,
        text: ObservationConstants.BodyHeightText
    };

    static readonly DialysisCode: string = '80662-0';
    static readonly DialysisDisplay: string = 'Volume of Peritoneal dialysis fluid';
    static readonly DialysisText: string = 'Dialysis';

    static readonly DialysisCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.DialysisCode,
        display: ObservationConstants.DialysisDisplay,
        text: ObservationConstants.DialysisText
    };

    static readonly EthnicityCode: string = '54133-4';
    static readonly EthnicityDisplay: string = 'Ethnicity';
    static readonly EthnicityText: string = 'Ethnicity';

    static readonly EthnicityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.EthnicityCode,
        display: ObservationConstants.EthnicityDisplay,
        text: ObservationConstants.EthnicityText
    };

    static readonly SpiroCode: string = '81458-2';
    static readonly SpiroDisplay: string = 'Pulmonary function test panel';
    static readonly SpiroText: string = 'Spiro';

    static readonly SpiroCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SpiroCode,
        display: ObservationConstants.SpiroDisplay,
        text: ObservationConstants.SpiroText
    };

    static readonly FEV1Code: string = '20150-9';
    static readonly FEV1Display: string = 'FEV1';
    static readonly FEV1Text: string = 'FEV1';

    static readonly FEV1CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FEV1Code,
        display: ObservationConstants.FEV1Display,
        text: ObservationConstants.FEV1Text
    };

    static readonly ForcedvitalcapacityCode: string = '19868-9';
    static readonly ForcedvitalcapacityDisplay: string = 'Forced vital capacity';
    static readonly ForcedvitalcapacityText: string = 'FVC';

    static readonly ForcedvitalcapacityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ForcedvitalcapacityCode,
        display: ObservationConstants.ForcedvitalcapacityDisplay,
        text: ObservationConstants.ForcedvitalcapacityText
    };

    static readonly PEFAirwayCode: string = '33452-4';
    static readonly PEFAirwayDisplay: string = 'PEF Airway';
    static readonly PEFAirwayText: string = 'PEF';

    static readonly PEFAirwayCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PEFAirwayCode,
        display: ObservationConstants.PEFAirwayDisplay,
        text: ObservationConstants.PEFAirwayText
    };

    static readonly FEFCode: string = '69971-0';
    static readonly FEFDisplay: string = 'FEF 25-75% Predicted';
    static readonly FEFText: string = 'FEF 25-75%';

    static readonly FEFCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FEFCode,
        display: ObservationConstants.FEFDisplay,
        text: ObservationConstants.FEFText
    };

    static readonly FEV1FVCCode: string = '19925-7';
    static readonly FEV1FVCDisplay: string = 'FEV1/FVC Predicted';
    static readonly FEV1FVCText: string = 'FEV1/FVC';

    static readonly FEV1FVCCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FEV1FVCCode,
        display: ObservationConstants.FEV1FVCDisplay,
        text: ObservationConstants.FEV1FVCText
    };

    static readonly GasFlowCode: string = '19930-7';
    static readonly GasFlowDisplay: string = 'Gas flow Respiratory system airway';
    static readonly GasFlowText: string = 'Flow rate';

    static readonly GasFlowCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.GasFlowCode,
        display: ObservationConstants.GasFlowDisplay,
        text: ObservationConstants.GasFlowText
    };

    static readonly GasVolumeCode: string = '20140-0';
    static readonly GasVolumeDisplay: string = 'Volume expired';
    static readonly GasVolumeText: string = 'Air volume';

    static readonly GasVolumeCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.GasVolumeCode,
        display: ObservationConstants.GasVolumeDisplay,
        text: ObservationConstants.GasVolumeText
    };

    static readonly NutrientCode: string = '75284-0';
    static readonly NutrientDisplay: string = 'Food and nutrient intake panel';
    static readonly NutrientText: string = 'Nutrition';

    static readonly NutrientCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.NutrientCode,
        display: ObservationConstants.NutrientDisplay,
        text: ObservationConstants.NutrientText
    };

    static readonly ProteinintakeEstimatedCode: string = '9079-5';
    static readonly ProteinintakeEstimatedDisplay: string = 'Protein intake Estimated';
    static readonly ProteinintakeEstimatedText: string = 'Protein intake Estimated';

    static readonly ProteinintakeEstimatedCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ProteinintakeEstimatedCode,
        display: ObservationConstants.ProteinintakeEstimatedDisplay,
        text: ObservationConstants.ProteinintakeEstimatedText
    };

    static readonly CarbohydrateintakeEstimatedCode: string = '9059-7';
    static readonly CarbohydrateintakeEstimatedDisplay: string = 'Carbohydrate intake Estimated';
    static readonly CarbohydrateintakeEstimatedText: string = 'Carbohydrate intake Estimated';

    static readonly CarbohydrateintakeEstimatedCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CarbohydrateintakeEstimatedCode,
        display: ObservationConstants.CarbohydrateintakeEstimatedDisplay,
        text: ObservationConstants.CarbohydrateintakeEstimatedText
    };

    static readonly FatintakeEstimatedCode: string = '9066-2';
    static readonly FatintakeEstimatedDisplay: string = 'Fat intake Estimated';
    static readonly FatintakeEstimatedText: string = 'Fat intake Estimated';

    static readonly FatintakeEstimatedCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FatintakeEstimatedCode,
        display: ObservationConstants.FatintakeEstimatedDisplay,
        text: ObservationConstants.FatintakeEstimatedText
    };

    static readonly BloodGlucoseCode: string = '15074-8';
    static readonly BloodGlucoseDisplay: string = 'Glucose [Moles/volume] in Blood';
    static readonly BloodGlucoseText: string = 'Glucose [Moles/volume] in Blood';

    static readonly GlucoseInBloodCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodGlucoseCode,
        display: ObservationConstants.BloodGlucoseDisplay,
        text: ObservationConstants.BloodGlucoseText
    };

    static readonly BloodGlucosePreMealCode: string = '88365-2';
    static readonly BloodGlucosePreMealDisplay: string = 'Glucose [Mass/volume] in Blood --pre-meal';
    static readonly BloodGlucosePreMealText: string = 'Glucose [Mass/volume] in Blood --pre-meal';

    static readonly GlucoseInBloodPreMealCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodGlucosePreMealCode,
        display: ObservationConstants.BloodGlucosePreMealDisplay,
        text: ObservationConstants.BloodGlucosePreMealText
    };

    static readonly BloodGlucosePostMealCode: string = '87422-2';
    static readonly BloodGlucosePostMealDisplay: string = 'Glucose [Mass/volume] in Blood --post meal';
    static readonly BloodGlucosePostMealText: string = 'Glucose [Mass/volume] in Blood --post meal';

    static readonly GlucoseInBloodPostMealCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BloodGlucosePostMealCode,
        display: ObservationConstants.BloodGlucosePostMealDisplay,
        text: ObservationConstants.BloodGlucosePostMealText
    };

    static readonly PulsoximeterCode: string = '43146-0';
    static readonly PulsoximeterDisplay: string = 'Oxygen saturation device panel';
    static readonly PulsoximeterText: string = 'Oxygen saturation device panel';

    static readonly PulsoximeterCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PulsoximeterCode,
        display: ObservationConstants.PulsoximeterDisplay,
        text: ObservationConstants.PulsoximeterText
    };

    static readonly HeartRatePulsoximeterCode: string = '8889-8';
    static readonly HeartRatePulsoximeterDisplay: string = 'Heart rate by Pulse oximetry';
    static readonly HeartRatePulsoximeterText: string = 'Realtime heart rate monitoring by Pulse oximetry';

    static readonly HeartRatePulsoximeterCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRatePulsoximeterCode,
        display: ObservationConstants.HeartRatePulsoximeterDisplay,
        text: ObservationConstants.HeartRatePulsoximeterText
    };

    static readonly OxygenSaturationPulsoximeterCode: string = '59408-5';
    static readonly OxygenSaturationPulsoximeterDisplay: string = 'Oxygen saturation in Arterial blood by Pulse oximetry';
    static readonly OxygenSaturationPulsoximeterText: string = 'Realtime oxygen saturation monitoring by Pulse oximetry';

    static readonly OxygenSaturationPulsoximeterCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OxygenSaturationPulsoximeterCode,
        display: ObservationConstants.OxygenSaturationPulsoximeterDisplay,
        text: ObservationConstants.OxygenSaturationPulsoximeterText
    };

    static readonly BodyTemperatureCode: string = '8310-5';
    static readonly BodyTemperatureDisplay: string = 'Body temperature';
    static readonly BodyTemperatureText: string = 'Body temperature';

    static readonly BodyTemperatureCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.BodyTemperatureCode,
        display: ObservationConstants.BodyTemperatureDisplay,
        text: ObservationConstants.BodyTemperatureText
    };

    static readonly RoomTemperatureCode: string = '60832-3';
    static readonly RoomTemperatureDisplay: string = 'Room temperature';
    static readonly RoomTemperatureText: string = 'Room temperature';

    static readonly RoomTemperatureCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.RoomTemperatureCode,
        display: ObservationConstants.RoomTemperatureDisplay,
        text: ObservationConstants.RoomTemperatureText
    };

    static readonly SteppingSessionCode: string = '55423-8';
    static readonly SteppingSessionDisplay: string = 'Number of steps in unspecified time Pedometer';
    static readonly SteppingSessionText: string = 'Number of steps in unspecified time Pedometer';

    static readonly SteppingSessionCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SteppingSessionCode,
        display: ObservationConstants.SteppingSessionDisplay,
        text: ObservationConstants.SteppingSessionText
    };

    static readonly StepsTakenCode: string = '66334-4';
    static readonly StepsTakenDisplay: string = 'Steps taken [#] [PhenX]';
    static readonly StepsTakenText: string = 'Measured steps by stairclimber machine';

    static readonly StepsTakenCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.StepsTakenCode,
        display: ObservationConstants.StepsTakenDisplay,
        text: ObservationConstants.StepsTakenText
    };

    static readonly TimePeriodStepsTakenCode: string = '66267-6';
    static readonly TimePeriodStepsTakenDisplay: string = 'Time period [PhenX] period (start, end)';
    static readonly TimePeriodStepsTakenText: string = 'Measured time period by stairclimber machine (start, end)';

    static readonly TimePeriodStepsTakenCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.TimePeriodStepsTakenCode,
        display: ObservationConstants.TimePeriodStepsTakenDisplay,
        text: ObservationConstants.TimePeriodStepsTakenText
    };

    static readonly RealtimePusoxiStepsCode: string = '55409-7';
    static readonly RealtimePusoxiStepsDisplay: string = 'Exercise tracking panel';
    static readonly RealtimePusoxiStepsText: string = 'Exercise tracking panel';

    static readonly RealtimePusoxiStepsCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.RealtimePusoxiStepsCode,
        display: ObservationConstants.RealtimePusoxiStepsDisplay,
        text: ObservationConstants.RealtimePusoxiStepsText
    };

    static readonly HeartRateWExerciseCode: string = '89273-7';
    static readonly HeartRateWExerciseDisplay: string = 'Heart rate --W exercise';
    static readonly HeartRateWExerciseText: string = 'Realtime heart rate monitoring by pulsoximeneter';

    static readonly HeartRateWExerciseCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateWExerciseCode,
        display: ObservationConstants.HeartRateWExerciseDisplay,
        text: ObservationConstants.HeartRateWExerciseText
    };

    static readonly OxygenSaturationWExerciseCode: string = '89276-0';
    static readonly OxygenSaturationWExerciseDisplay: string = 'Oxygen saturation in Arterial blood by Pulse oximetry --W exercise';
    static readonly OxygenSaturationWExerciseText: string = 'Realtime oxygen saturation monitoring by pulsoximeneter';

    static readonly OxygenSaturationWExerciseCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OxygenSaturationWExerciseCode,
        display: ObservationConstants.OxygenSaturationWExerciseDisplay,
        text: ObservationConstants.OxygenSaturationWExerciseText
    };

    static readonly MiBandPulseCode: string = '55425-3';
    static readonly MiBandPulseDisplay: string = 'Heart rate unspecified time mean by Pedometer';
    static readonly MiBandPulseText: string = 'MiBand heart rate measure';

    static readonly MiBandPulseCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.MiBandPulseCode,
        display: ObservationConstants.MiBandPulseDisplay,
        text: ObservationConstants.MiBandPulseText
    };

    static readonly OtolaryngologyCode: string = '78575-8';
    static readonly OtolaryngologyDisplay: string = 'Otolaryngology Diagnostic study note';
    static readonly OtolaryngologyText: string = 'Otolaryngology Diagnostic study note';

    static readonly OtolaryngologyCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OtolaryngologyCode,
        display: ObservationConstants.OtolaryngologyDisplay,
        text: ObservationConstants.OtolaryngologyText
    };

    static readonly PainQualityCode: string = '32419-4';
    static readonly PainQualityDisplay: string = 'Pain quality';
    static readonly PainQualityText: string = 'Intensity';

    static readonly PainQualityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PainQualityCode,
        display: ObservationConstants.PainQualityDisplay,
        text: ObservationConstants.PainQualityText
    };

    static readonly PainOnsetCode: string = '38201-0';
    static readonly PainOnsetDisplay: string = 'Pain onset [Date and time]';
    static readonly PainOnsetText: string = 'Beginning';

    static readonly PainOnsetCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PainOnsetCode,
        display: ObservationConstants.PainOnsetDisplay,
        text: ObservationConstants.PainOnsetText
    };

    static readonly PhysicalFindingsOfEarCode: string = '8698-3';
    static readonly PhysicalFindingsOfEarDisplay: string = 'Physical findings of Ear';
    static readonly PhysicalFindingsOfEarText: string = 'Nature of irradization';

    static readonly PhysicalFindingsOfEarCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PhysicalFindingsOfEarCode,
        display: ObservationConstants.PhysicalFindingsOfEarDisplay,
        text: ObservationConstants.PhysicalFindingsOfEarText
    };

    static readonly ColorOfUnspecifiedSpecimenCode: string = '33512-5';
    static readonly ColorOfUnspecifiedSpecimenDisplay: string = 'Color of Unspecified specimen';
    static readonly ColorOfUnspecifiedSpecimenText: string = 'Color';

    static readonly ColorOfUnspecifiedSpecimenCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ColorOfUnspecifiedSpecimenCode,
        display: ObservationConstants.ColorOfUnspecifiedSpecimenDisplay,
        text: ObservationConstants.ColorOfUnspecifiedSpecimenText
    };

    static readonly ColorOfUnspecifiedSpecimenKonzCode: string = '33512-5-2';
    static readonly ColorOfUnspecifiedSpecimenKonzDisplay: string = 'Color of Unspecified specimen';
    static readonly ColorOfUnspecifiedSpecimenKonzText: string = 'Consistency';

    static readonly ColorOfUnspecifiedSpecimenKonzCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ColorOfUnspecifiedSpecimenKonzCode,
        display: ObservationConstants.ColorOfUnspecifiedSpecimenKonzDisplay,
        text: ObservationConstants.ColorOfUnspecifiedSpecimenKonzText
    };

    static readonly AgeOfUnspecifiedSpecimenCode: string = '57900-3';
    static readonly AgeOfUnspecifiedSpecimenDisplay: string = 'Age of Unspecified specimen';
    static readonly AgeOfUnspecifiedSpecimenText: string = 'Beginning';

    static readonly AgeOfUnspecifiedSpecimenCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.AgeOfUnspecifiedSpecimenCode,
        display: ObservationConstants.AgeOfUnspecifiedSpecimenDisplay,
        text: ObservationConstants.AgeOfUnspecifiedSpecimenText
    };

    static readonly EarIchingCode: string = '70451-0';
    static readonly EarIchingDisplay: string = 'I am bothered by itching in past 7 days';
    static readonly EarIchingText: string = 'Ear itching';

    static readonly EarIchingCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.EarIchingCode,
        display: ObservationConstants.EarIchingDisplay,
        text: ObservationConstants.EarIchingText
    };

    static readonly PhysicalFindingsOfHearingCode: string = '32437-6';
    static readonly PhysicalFindingsOfHearingDisplay: string = 'Physical findings of Hearing';
    static readonly PhysicalFindingsOfHearingText: string = 'Hearing loss';

    static readonly PhysicalFindingsOfHearingCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PhysicalFindingsOfHearingCode,
        display: ObservationConstants.PhysicalFindingsOfHearingDisplay,
        text: ObservationConstants.PhysicalFindingsOfHearingText
    };

    static readonly InfectionCode: string = '28124-6';
    static readonly InfectionDisplay: string = 'Infection [CCC]';
    static readonly InfectionText: string = 'Upper';

    static readonly InfectionCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.InfectionCode,
        display: ObservationConstants.InfectionDisplay,
        text: ObservationConstants.InfectionText
    };

    static readonly RetroauricularisPainCode: string = '8698-3-2';
    static readonly RetroauricularisPainDisplay: string = 'Physical findings of Ear-2';
    static readonly RetroauricularisPainText: string = 'Retroauricularis pain, swelling';

    static readonly RetroauricularisPainCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.RetroauricularisPainCode,
        display: ObservationConstants.RetroauricularisPainDisplay,
        text: ObservationConstants.RetroauricularisPainText
    };

    static readonly DizzinessCode: string = '45699-6';
    static readonly DizzinessDisplay: string = 'Dizziness or vertigo';
    static readonly DizzinessText: string = 'Dizziness';

    static readonly DizzinessCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.DizzinessCode,
        display: ObservationConstants.DizzinessDisplay,
        text: ObservationConstants.DizzinessText
    };

    static readonly NoiseCode: string = '46686-2';
    static readonly NoiseDisplay: string = 'Noise [RFC]';
    static readonly NoiseText: string = 'Side';

    static readonly NoiseCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.NoiseCode,
        display: ObservationConstants.NoiseDisplay,
        text: ObservationConstants.NoiseText
    };

    static readonly ParalysisCode: string = '80326-2';
    static readonly ParalysisDisplay: string = 'Paralysis [Type]';
    static readonly ParalysisText: string = 'Facial paralysis';

    static readonly ParalysisCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ParalysisCode,
        display: ObservationConstants.ParalysisDisplay,
        text: ObservationConstants.ParalysisText
    };

    static readonly OtolaryngologyHistoryAndPhysycalNoteCode: string = '84366-4';
    static readonly OtolaryngologyHistoryAndPhysycalNoteDisplay: string = 'Otolaryngology History and physical note';
    static readonly OtolaryngologyHistoryAndPhysycalNoteText: string = 'Symptom / hystory / note';

    static readonly OtolaryngologyHistoryAndPhysycalNoteCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OtolaryngologyHistoryAndPhysycalNoteCode,
        display: ObservationConstants.OtolaryngologyHistoryAndPhysycalNoteDisplay,
        text: ObservationConstants.OtolaryngologyHistoryAndPhysycalNoteText
    };

    static readonly OtolaryngologyNote2Code: string = '34817-7-2';
    static readonly OtolaryngologyNote2Display: string = 'Otolaryngology Note-2';
    static readonly OtolaryngologyNote2Text: string = 'Symptom / hystory / note';

    static readonly OtolaryngologyNote2CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OtolaryngologyNote2Code,
        display: ObservationConstants.OtolaryngologyNote2Display,
        text: ObservationConstants.OtolaryngologyNote2Text
    };

    static readonly OtolaryngologySurgicalOperationNoteCode: string = '34818-5';
    static readonly OtolaryngologySurgicalOperationNoteDisplay: string = 'Otolaryngology Surgical operation note';
    static readonly OtolaryngologySurgicalOperationNoteText: string = 'Operation';

    static readonly OtolaryngologySurgicalOperationNoteCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OtolaryngologySurgicalOperationNoteCode,
        display: ObservationConstants.OtolaryngologySurgicalOperationNoteDisplay,
        text: ObservationConstants.OtolaryngologySurgicalOperationNoteText
    };

    static readonly SurgicalOperationNoteDateCode: string = '8723-9';
    static readonly SurgicalOperationNoteDateDisplay: string = 'Surgical operation note date';
    static readonly SurgicalOperationNoteDateText: string = 'Operation';

    static readonly SurgicalOperationNoteDateCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SurgicalOperationNoteDateCode,
        display: ObservationConstants.SurgicalOperationNoteDateDisplay,
        text: ObservationConstants.SurgicalOperationNoteDateText
    };

    static readonly OtolaryngologyPlanOfCareNoteCode: string = '80778-4';
    static readonly OtolaryngologyPlanOfCareNoteDisplay: string = 'Otolaryngology Plan of care note';
    static readonly OtolaryngologyPlanOfCareNoteText: string = 'Therapy';

    static readonly OtolaryngologyPlanOfCareNoteCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OtolaryngologyPlanOfCareNoteCode,
        display: ObservationConstants.OtolaryngologyPlanOfCareNoteDisplay,
        text: ObservationConstants.OtolaryngologyPlanOfCareNoteText
    };

    static readonly StartOfCareDateCode: string = '46497-4';
    static readonly StartOfCareDateDisplay: string = 'Start of care date [OASIS]';
    static readonly StartOfCareDateText: string = 'Therapy';

    static readonly StartOfCareDateCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.StartOfCareDateCode,
        display: ObservationConstants.StartOfCareDateDisplay,
        text: ObservationConstants.StartOfCareDateText
    };

    static readonly OtolaryngologyNoteCode: string = '34817-7';
    static readonly OtolaryngologyNoteDisplay: string = 'Otolaryngology Note';
    static readonly OtolaryngologyNoteText: string = 'Othernote';

    static readonly OtolaryngologyNoteCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.OtolaryngologyNoteCode,
        display: ObservationConstants.OtolaryngologyNoteDisplay,
        text: ObservationConstants.OtolaryngologyNoteText
    };

    static readonly DiagnosticImagingStudyCode: string = '18748-4';
    static readonly DiagnosticImagingStudyDisplay: string = 'Diagnostic imaging study';
    static readonly DiagnosticImagingStudyText: string = 'Image';

    static readonly DiagnosticImagingStudyCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.DiagnosticImagingStudyCode,
        display: ObservationConstants.DiagnosticImagingStudyDisplay,
        text: ObservationConstants.DiagnosticImagingStudyText
    };



    static readonly FoodAndNutrientIntakepanelCode: string = '75284-0';
    static readonly FoodAndNutrientIntakepanelCodeDisplay: string = 'Food and nutrient intake panel';
    static readonly FoodAndNutrientIntakepanelCodeText: string = 'Food and nutrient intake panel';

    static readonly CFoodAndNutrientIntakepanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FoodAndNutrientIntakepanelCode,
        display: ObservationConstants.FoodAndNutrientIntakepanelCodeDisplay,
        text: ObservationConstants.FoodAndNutrientIntakepanelCodeText
    };




    static readonly CalorieIntakePanelCode: string = '80443-5';
    static readonly CalorieIntakePanelCodeDisplay: string = 'Calorie intake panel';
    static readonly CalorieIntakePanelCodeText: string = 'Calorie intake panel';

    static readonly CalorieIntakePanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CalorieIntakePanelCode,
        display: ObservationConstants.CalorieIntakePanelCodeDisplay,
        text: ObservationConstants.CalorieIntakePanelCodeText
    };

    static readonly CarbohydrateIntakePanelCode: string = '81940-9';
    static readonly CarbohydrateIntakePanelDisplay: string = 'Carbohydrate intake panel';
    static readonly CarbohydrateIntakePanelCodeText: string = 'Carbohydrate intake panel';

    static readonly CarbohydrateIntakePanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CarbohydrateIntakePanelCode,
        display: ObservationConstants.CarbohydrateIntakePanelDisplay,
        text: ObservationConstants.CarbohydrateIntakePanelCodeText
    };


    static readonly FatIntakePanelCode: string = '81896-3';
    static readonly FatIntakePanelDisplay: string = 'Fat intake panel';
    static readonly FatIntakePanelCodeText: string = 'Fat intake panel';

    static readonly FatIntakePanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FatIntakePanelCode,
        display: ObservationConstants.FatIntakePanelDisplay,
        text: ObservationConstants.FatIntakePanelCodeText
    };


    static readonly ProteinIntakePanelCode: string = '81904-5';
    static readonly ProteinIntakePanelDisplay: string = 'Protein intake panel';
    static readonly ProteinIntakePanelCodeText: string = 'Protein intake panel';

    static readonly ProteinIntakePanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ProteinIntakePanelCode,
        display: ObservationConstants.ProteinIntakePanelDisplay,
        text: ObservationConstants.ProteinIntakePanelCodeText
    };

    static readonly FoodAmountsPanelCode: string = '80445-0';
    static readonly FoodAmountsPanelDisplay: string = 'Food amounts panel';
    static readonly FoodAmountsPanelCodeText: string = 'Food amounts panel';

    static readonly FoodAmountsPanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FoodAmountsPanelCode,
        display: ObservationConstants.FoodAmountsPanelDisplay,
        text: ObservationConstants.FoodAmountsPanelCodeText
    };

    static readonly FunctionalExaminationCode: string = '76453-0';
    static readonly FunctionalExaminationDisplay: string = 'Physical therapy initial visit panel';
    static readonly FunctionalExaminationText: string = 'Physical therapy initial visit panel';

    static readonly FunctionalExaminationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FunctionalExaminationCode,
        display: ObservationConstants.FunctionalExaminationDisplay,
        text: ObservationConstants.FunctionalExaminationText
    };

    static readonly SurveyScoreCode: string = '82668-5';
    static readonly SurveyScoreDisplay: string = 'Total score [ACT]';
    static readonly SurveyScoreText: string = 'Total score [ACT]';

    static readonly SurveyScoreCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.SurveyScoreCode,
        display: ObservationConstants.SurveyScoreDisplay,
        text: ObservationConstants.SurveyScoreText
    };

    static readonly AgeCode: string = '29553-5';
    static readonly AgeDisplay: string = 'Age calculated';
    static readonly AgeText: string = 'Age calculated';

    static readonly AgeCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.AgeCode,
        display: ObservationConstants.AgeDisplay,
        text: ObservationConstants.AgeText
    };

    static readonly PatientMoodCode: string = '80296-7';
    static readonly PatientMoodDisplay: string = 'Patient Mood';
    static readonly PatientMoodText: string = 'Patient Mood';

    static readonly PatientMoodCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.PatientMoodCode,
        display: ObservationConstants.PatientMoodDisplay,
        text: ObservationConstants.PatientMoodText
    };

    static readonly FiberIntakePanelCode: string = '81926-8';
    static readonly FiberIntakePanelDisplay: string = 'Fiber intake panel';
    static readonly FiberIntakePanelText: string = 'Fiber intake panel';

    static readonly FiberIntakePanelCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FiberIntakePanelCode,
        display: ObservationConstants.FiberIntakePanelDisplay,
        text: ObservationConstants.FiberIntakePanelText
    };

    static readonly AsthmaCode: string = '45669-9';
    static readonly AsthmaDisplay: string = 'Asthma [Minimum Data Set]';
    static readonly AsthmaText: string = 'Asthma [Minimum Data Set]';

    static readonly AsthmaCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.AsthmaCode,
        display: ObservationConstants.AsthmaDisplay,
        text: ObservationConstants.AsthmaText
    };

    static readonly LoggingActivityCode: string = '75280-8';
    static readonly LoggingActivityDisplay: string = 'Sequence number in substance administration series';
    static readonly LoggingActivityText: string = 'Sequence number in substance administration series';

    static readonly LoggingActivityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.LoggingActivityCode,
        display: ObservationConstants.LoggingActivityDisplay,
        text: ObservationConstants.LoggingActivityText
    };

    static readonly CaloriesBurnedCode: string = '41981-2';
    static readonly CaloriesBurnedDisplay: string = 'Calories burned';
    static readonly CaloriesBurnedText: string = 'Calories burned';

    static readonly CaloriesBurnedCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CaloriesBurnedCode,
        display: ObservationConstants.CaloriesBurnedDisplay,
        text: ObservationConstants.CaloriesBurnedText
    };

    static readonly HeartRateVariabilityCode: string = '80404-7';
    static readonly HeartRateVariabilityDisplay: string = 'R-R interval.standard deviation (Heart rate variability)';
    static readonly HeartRateVariabilityText: string = 'R-R interval.standard deviation (Heart rate variability)';

    static readonly HeartRateVariabilityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateVariabilityCode,
        display: ObservationConstants.HeartRateVariabilityDisplay,
        text: ObservationConstants.HeartRateVariabilityText
    };

    static readonly ExerciseDurationCode: string = '55411-3';
    static readonly ExerciseDurationDisplay: string = 'Exercise duration';
    static readonly ExerciseDurationText: string = 'Exercise duration';

    static readonly ExerciseDurationCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ExerciseDurationCode,
        display: ObservationConstants.ExerciseDurationDisplay,
        text: ObservationConstants.ExerciseDurationText
    };

    static readonly ExerciseTypeCode: string = '66286-6';
    static readonly ExerciseTypeDisplay: string = 'Other type of physical activity [PhenX]';
    static readonly ExerciseTypeText: string = 'Other type of physical activity [PhenX]';

    static readonly ExerciseTypeCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ExerciseTypeCode,
        display: ObservationConstants.ExerciseTypeDisplay,
        text: ObservationConstants.ExerciseTypeText
    };

    static readonly HeartRateLvl1Code: string = '8888-1';
    static readonly HeartRateLvl1Display: string = 'Heart rate measure duration Level1';
    static readonly HeartRateLvl1Text: string = 'Heart rate measure duration Level1';

    static readonly HeartRateLvl1CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateLvl1Code,
        display: ObservationConstants.HeartRateLvl1Display,
        text: ObservationConstants.HeartRateLvl1Text
    };

    static readonly HeartRateLvl2Code: string = '8888-2';
    static readonly HeartRateLvl2Display: string = 'Heart rate measure duration Level2';
    static readonly HeartRateLvl2Text: string = 'Heart rate measure duration Level2';

    static readonly HeartRateLvl2CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateLvl2Code,
        display: ObservationConstants.HeartRateLvl2Display,
        text: ObservationConstants.HeartRateLvl2Text
    };

    static readonly HeartRateLvl3Code: string = '8888-3';
    static readonly HeartRateLvl3Display: string = 'Heart rate measure duration Level3';
    static readonly HeartRateLvl3Text: string = 'Heart rate measure duration Level3';

    static readonly HeartRateLvl3CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateLvl3Code,
        display: ObservationConstants.HeartRateLvl3Display,
        text: ObservationConstants.HeartRateLvl3Text
    };

    static readonly HeartRateLvl4Code: string = '8888-4';
    static readonly HeartRateLvl4Display: string = 'Heart rate measure duration Level4';
    static readonly HeartRateLvl4Text: string = 'Heart rate measure duration Level4';

    static readonly HeartRateLvl4CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateLvl4Code,
        display: ObservationConstants.HeartRateLvl4Display,
        text: ObservationConstants.HeartRateLvl4Text
    };

    static readonly HeartRateLvl5Code: string = '8888-5';
    static readonly HeartRateLvl5Display: string = 'Heart rate measure duration Level5';
    static readonly HeartRateLvl5Text: string = 'Heart rate measure duration Level5';

    static readonly HeartRateLvl5CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.HeartRateLvl5Code,
        display: ObservationConstants.HeartRateLvl5Display,
        text: ObservationConstants.HeartRateLvl5Text
    };

    static readonly ExerciseIntensityCode: string = '74008-4';
    static readonly ExerciseIntensityDisplay: string = 'Exercise intensity';
    static readonly ExerciseIntensityText: string = 'Exercise intensity';

    static readonly ExerciseIntensityCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ExerciseIntensityCode,
        display: ObservationConstants.ExerciseIntensityDisplay,
        text: ObservationConstants.ExerciseIntensityText
    };

    static readonly IL12Code: string = '41760-0';
    static readonly IL12Display: string = 'Interleukin 12 [Mass/Vol]';
    static readonly IL12Text: string = 'Interleukin 12 [Mass/volume] in Serum or Plasma';

    static readonly IL12CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.IL12Code,
        display: ObservationConstants.IL12Display,
        text: ObservationConstants.IL12Text
    };

    static readonly IL6Code: string = '26881-3';
    static readonly IL6Display: string = 'Interleukin 6 [Mass/Vol]';
    static readonly IL6Text: string = 'Interleukin 6 [Mass/volume] in Serum or Plasma';

    static readonly IL6CodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.IL6Code,
        display: ObservationConstants.IL6Display,
        text: ObservationConstants.IL6Text
    };

    static readonly CRPCode: string = '1988-5';
    static readonly CRPDisplay: string = 'CRP [Mass/Vol]';
    static readonly CRPText: string = 'C reactive protein [Mass/volume] in Serum or Plasma';

    static readonly CRPCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CRPCode,
        display: ObservationConstants.CRPDisplay,
        text: ObservationConstants.CRPText
    };

    static readonly CortisolCode: string = '2143-6';
    static readonly CortisolDisplay: string = 'Cortisol [Mass/Vol]';
    static readonly CortisolText: string = 'Cortisol [Mass/volume] in Serum or Plasma';

    static readonly CortisolCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.CortisolCode,
        display: ObservationConstants.CortisolDisplay,
        text: ObservationConstants.CortisolText
    };

    static readonly FlankerCode: string = '84465-4';
    static readonly FlankerDisplay: string = 'Flanker - computed score NIH';
    static readonly FlankerText: string = 'Flanker Inhibitory Control and Attention Test - computed score [NIH Toolbox]';

    static readonly FlankerCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.FlankerCode,
        display: ObservationConstants.FlankerDisplay,
        text: ObservationConstants.FlankerText
    };

    static readonly TasksCode: string = '60703-6';
    static readonly TasksDisplay: string = 'Total observed item score [TIMP]';
    static readonly TasksText: string = 'Total observed item score [TIMP]';

    static readonly TasksCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.TasksCode,
        display: ObservationConstants.TasksDisplay,
        text: ObservationConstants.TasksText
    };

    static readonly AnswerRatioCode: string = '91587-6';
    static readonly AnswerRatioDisplay: string = 'Accuracy of information from source';
    static readonly AnswerRatioText: string = 'Accuracy of information from source';

    static readonly AnswerRatioCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.AnswerRatioCode,
        display: ObservationConstants.AnswerRatioDisplay,
        text: ObservationConstants.AnswerRatioText
    };

    static readonly ResponseTimeCode: string = '67262-6';
    static readonly ResponseTimeDisplay: string = 'Answer questions PhenX';
    static readonly ResponseTimeText: string = 'My child\'s ability to answer questions properly is [PhenX]';

    static readonly ResponseTimeCodeModel: CodeModel = {
        system: ObservationConstants.ObservationSystem,
        code: ObservationConstants.ResponseTimeCode,
        display: ObservationConstants.ResponseTimeDisplay,
        text: ObservationConstants.ResponseTimeText
    };
}


export enum BloodTypes {
    ZeroPositive = '0+',
    ZeroNegative = '0-',
    APositive = 'A+',
    ANegative = 'A-',
    BPositive = 'B+',
    BNegative = 'B-',
    ABPositive = 'AB+',
    ABNegative = 'AB-'
}

export enum DetectedIssueSeverities {
    Low = 'low',
    Medium = 'medium',
    High = 'high'
}

export enum ResultTableTypes {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly'
}

export enum ChartTypes {
    BloodPressure = 'bloodpressure',
    Weight = 'weight',
    Activity = 'activity'
}

export enum ResultTableDataTypes {
    All = 'all',
    Average = 'avg'
}
